
import ServiceTypeRequestPtDetailEntity from "../entities/pt/ServiceTypeRequestPtDetail.Entity";
import { apiDelete} from '../support/helpers/ApiConnection.Helper';

export function deleteServiceTypeRequestPtDetail(serviceTypeRequestPtDetailId: number, abortSignal: AbortSignal): Promise<ServiceTypeRequestPtDetailEntity> {
    return apiDelete<ServiceTypeRequestPtDetailEntity>('/service-type-request-pt-detail', serviceTypeRequestPtDetailId, abortSignal);
}